import { fetchBranchDetailsData, updateBranchSetting } from '_services/accountsServices/branchServices';
import { fetchInvoiceNumberData, fetchTripNumberData } from '_services/accountsServices/lrServices';
import { CommonInput } from 'components'
import { UserContext } from 'context';
import { AddNewSeriesTripModal, BranchSeriesInvoiceModal, BranchSeriesModal } from 'modals';
import AddNewSeriesInvoiceModal from 'modals/AddNewSeriesInvoiceModal/AddNewSeriesInvoiceModal';
import React, { useContext, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices';

const status = [
  { title: "Available", value: "available" },
  { title: "Not Available", value: "not_available" },
  { title: "premium", value: "premium" },
  { title: "Coming soon", value: "coming_soon" }

]

const BranchSetting = ({ onDataFetch }) => {

  let { id } = useParams();


  const disableValue = {
    registration_certificate: 0,
    puc: 0,
    fitness: 0,
    ionsurance: 0,
    national_permit: 0
  }

  const supplier_freight = {
    view: 0,
    mandatory: 0,
  }

  const supplier_bank_account = {
    view: 0,
    mandatory: 0,
  }

  const loading_challi = {
    view: 0,
    mandatory: 0,
  }

  const market_drive_on_dispatch = {
    view: 0,
    mandatory: 0,
  }


  const { masterData } = useContext(UserContext)
  const [detailsData, setDetailsData] = useState({})
  const [loading, setLoading] = useState(false);
  const companyId = StorageService.getCompanyId();
  const [supplierFeight, setSupplierFeight] = useState(supplier_freight);
  const [supplierBankAccount, setSupplierBankAccount] = useState(supplier_bank_account);
  const [loadingChalli, setLoadingChalli] = useState(loading_challi);
  const [marketDriver, setMarketDriver] = useState(market_drive_on_dispatch)
  const [disableButton, setDisableButton] = useState(true);
  const originalFormRef = useRef(null);
  const [isOpenLrSeries, setIsOpenLrSeries] = useState(false);
  const [showAddNewLrSeries, setShowAddNewLrSeries] = useState(false);
  const [isSetLrSeries, setIsSetLrSeries] = useState("");
  const [isEditLR, setIsEditLR] = useState(false);
  const [isLrNumber, setIsLrNumber] = useState("");

  const [isOpenInvoiceSeries, setIsOpenInvoiceSeries] = useState(false);
  const [showAddNewInvoiceSeries, setShowAddNewInvoiceSeries] = useState(false);
  const [isSetInvoiceSeries, setIsSetInvoiceSeries] = useState("");
  const [isEditInvoice, setIsEditInvoice] = useState(false);
  const [isInvoiceNumber, setIsInvoiceNumber] = useState("");
  const [branchSettingPermi, setBranchSettingPermi] = useState({})
  const [showPermision, setShowPermision] = useState({
    dispatch_setting: {},
    print_setting: {}
  })

  const documentChecklist = [
    'Registration Certificate',
    'PUC',
    'Fitness',
    'Insurance',
    'National Permit',
  ];

  const initialFormValues = {

    company_id: "",
    branch_id: "",
    fssai_licence: "",
    terms_conditions: "",
    lr_bilty_format: 0,
    permission_at_supplier: {
      supplier_freight: supplierFeight,
      supplier_bank_account: supplierBankAccount,
    },
    pod_before_trip_end: 0,
    loading_challi: loadingChalli,
    dispatch_date_time: 0,
    market_drive_on_dispatch: marketDriver,
    route_customization_on_trip: 0,
    supplier_selection_at_dispatch: 0,
  };
  const [form, setForm] = useState(initialFormValues);
  const [tripSeries, setTripSeries] = useState('')
  const [invoiceSeries, setInvoiceSeries] = useState('')

  useEffect(() => {
    if (id) {
      // setLoading(true);
      getDataBranchDetails(id, companyId);
    }
  }, [id, masterData])

  useEffect(() => {
    if (originalFormRef.current) {
      const isSame = JSON.stringify(originalFormRef.current) === JSON.stringify(form);
      setDisableButton(isSame); // true = disable button, false = enable
    }
  }, [form]);

  useEffect(() => {
    // if (!isOpen?.isEditLr && isLrStatus != 1) {
    if (form?.branch_id) {
      getDataLrNumber(form?.branch_id);
      getDataInvoiceNumber(form?.branch_id)

    }
    // }
  }, [form?.branch_id]);

  const getDataBranchDetails = async (id_1, id_2) => {
    try {
      const object = {
        branch_id: id_1,
        company_id: id_2,
      };
      const res = await fetchBranchDetailsData(object);

      if (res?.responseCode === 200) {
        const apiData = res?.data?.branch;
        const formattedData = {
          company_id: apiData.company_id || "",
          branch_id: apiData._id || "",
          fssai_licence: apiData.fssai_licence || "",
          terms_conditions: apiData.terms_conditions || "",
          lr_bilty_format: apiData.lr_bilty_format ?? 1,
          permission_at_supplier: {
            supplier_freight: {
              view: apiData.permission_at_supplier?.supplier_freight?.view ?? 0,
              mandatory: apiData.permission_at_supplier?.supplier_freight?.mandatory ?? 0,
            },
            supplier_bank_account: {
              view: apiData.permission_at_supplier?.supplier_bank_account?.view ?? 0,
              mandatory: apiData.permission_at_supplier?.supplier_bank_account?.mandatory ?? 0,
            },
          },

          pod_before_trip_end: apiData.pod_before_trip_end ?? 0,

          loading_challi: {
            view: apiData.loading_challi?.view ?? 0,
            mandatory: apiData.loading_challi?.mandatory ?? 0,
          },

          dispatch_date_time: apiData.dispatch_date_time ?? 0,

          market_drive_on_dispatch: {
            view: apiData.market_drive_on_dispatch?.view ?? 0,
            mandatory: apiData.market_drive_on_dispatch?.mandatory ?? 0,
          },
          route_customization_on_trip: apiData.route_customization_on_trip ?? 0,
          supplier_selection_at_dispatch: apiData.supplier_selection_at_dispatch ?? 0,
        };

        setForm(formattedData);
        originalFormRef.current = formattedData; // ✅ Set reference to original
        const findBranchSetting = apiData?.company_id?.subscription_data?.company_settings?.find((i) => i?.sort == 3)
        setBranchSettingPermi(findBranchSetting)
        setDetailsData(apiData);
        onDataFetch(apiData);
        setDisableButton(true); // Since no changes yet
      }
    } catch (error) {
      // handle error
    } finally {
      // setLoading(false);
    }
  };

  const handleOnChange = (name, value) => {
    const keys = name.split(".");

    setForm(prev => {
      let updated = { ...prev };

      // Handle 3-level nested updates
      if (keys.length === 3) {
        const [lvl1, lvl2, lvl3] = keys;

        const isViewField = lvl3 === "view";
        const isUncheckingView = isViewField && value === 0;

        // Base update
        updated = {
          ...prev,
          [lvl1]: {
            ...prev[lvl1],
            [lvl2]: {
              ...prev[lvl1][lvl2],
              [lvl3]: value,
              ...(isUncheckingView && { mandatory: 0 }), // Reset mandatory if view is unchecked
            },
          },
        };
      }

      // Handle 2-level nesting
      else if (keys.length === 2) {
        const [parentKey, childKey] = keys;
        const isViewField = childKey === "view";
        const isUncheckingView = isViewField && value === 0;
        updated = {
          ...prev,
          [parentKey]: {
            ...prev[parentKey],
            [childKey]: value,
            ...(isUncheckingView && { mandatory: 0 }),
          },
        };
      }

      // Top-level
      else {
        updated = {
          ...prev,
          [name]: Number(value),
        };
      }

      return updated;
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const data = {
      ...form,

    }
    try {
      const res = await updateBranchSetting(data);
      if (res?.responseCode == 200) {
        setLoading(false);
        toast.success("Branch setting updated successfully");
        getDataBranchDetails(id, companyId);
      } else {
        setLoading(false);
        // toast.error(res?.responseMessage)
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  const handleLrFunctionality = () => {
    // if (!isOpen?.isEditLr) {
    setIsOpenLrSeries(true);
    // }
  };

  const handleInvoiceFunctionality = () => {
    // if (!isOpen?.isEditLr) {
    setIsOpenInvoiceSeries(true);
    // }
  };



  const getDataLrNumber = async (id) => {
    try {
      let object = {
        branch_id: id,
      };
      const res = await fetchTripNumberData(object);
      if (res?.responseCode == 200) {
        // setForm((s) => ({ ...s, trip_number: res?.data?.trip_number }));
        setTripSeries(res?.data?.trip_number);
      }
    } catch (error) {
      // throw error;
    }
  };

  const getDataInvoiceNumber = async (id) => {
    try {
      let object = {
        branch_id: id,
      };
      const res = await fetchInvoiceNumberData(object);
      if (res?.responseCode == 200) {
        // setForm((s) => ({ ...s, trip_number: res?.data?.trip_number }));
        setInvoiceSeries(res?.data?.billraise_number);
      }
    } catch (error) {
      // throw error;
    }
  };


  useEffect(() => {
    if (branchSettingPermi?.permissions?.length) {

      const Dispatch_settings_for_Branch = branchSettingPermi?.permissions?.find((i) => i?.name == "Dispatch Settings for Branch")
      const Print_Number_Generation = branchSettingPermi?.permissions?.find((i) => i?.name == "Print Number Generation")

      setShowPermision((pre) => ({
        ...pre, dispatch_setting: { ...Dispatch_settings_for_Branch, status: getStatusTitle(Dispatch_settings_for_Branch) },
        print_setting: { ...Print_Number_Generation, status: getStatusTitle(Print_Number_Generation) }
      }))
    }
  }, [branchSettingPermi])

  const getStatusTitle = (item) => {
    const statusItem = status.find((st) => item[st.value] === 1);
    return statusItem ? statusItem.title : "";
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Available":
        return "success";
      case "Not Available":
        return "danger";
      case "Premium":
        return "warning";
      case "Coming Soon":
        return "info";
      default:
        return "secondary";
    }
  };

  let isLrSeriesModalProps = {
    isOpen: isOpenLrSeries,
    closeModal: () => setIsOpenLrSeries(!isOpenLrSeries),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Select Trip Series",
    formData: form,
    submitTitle: "Save",
    nextModal: (e) => setShowAddNewLrSeries(true),
    setIsEditLR: (e) => setIsEditLR(e),
    setLrSeries: (e) => setIsSetLrSeries(e),
    setIsLrNumber: (e) => setIsLrNumber(e),
  };

  let isInvoiceSeriesModalProps = {
    isOpen: isOpenInvoiceSeries,
    closeModal: () => setIsOpenInvoiceSeries(!isOpenInvoiceSeries),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Select Invoice Series",
    formData: form,
    submitTitle: "Save",
    nextModal: (e) => setShowAddNewInvoiceSeries(true),
    setIsEditLR: (e) => setIsEditInvoice(e),
    setLrSeries: (e) => setIsSetInvoiceSeries(e),
    setIsLrNumber: (e) => setIsInvoiceNumber(e),
  };
  let addNewSeriesModalProps = {
    isOpen: showAddNewLrSeries,
    closeModal: () => setShowAddNewLrSeries(!showAddNewLrSeries),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: isEditLR?._id ? "Edit New Series" : "Add New Series",
    submitTitle: isEditLR?._id ? "Update" : "Save",
    formData: form,
    isEditLR: isEditLR,
    onSubmit: (e) => setShowAddNewLrSeries(false),
    previosModal: () => setIsOpenLrSeries(!isOpenLrSeries),
  };

  let addNewSeriesInvoiceModalProps = {
    isOpen: showAddNewInvoiceSeries,
    closeModal: () => setShowAddNewInvoiceSeries(!showAddNewInvoiceSeries),
    headerPart: false,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: isEditInvoice?._id ? "Edit New Series" : "Add New Series",
    submitTitle: isEditInvoice?._id ? "Update" : "Save",
    formData: form,
    isEditLR: isEditInvoice,
    onSubmit: (e) => setShowAddNewInvoiceSeries(false),
    previosModal: () => setIsOpenInvoiceSeries(!isOpenInvoiceSeries),
  };


  return (
    <>
      <div className='__setBr_main'>
        <div className='__setf_brancOtr'>
          <div className='__setf_brancInner'>
            <div className='__setf_brancBx'>
              <div className='__setf_brHead'>
                <h4>Dispatch Settings for Branch  <span
                  className={`badge bg-${getStatusColor(showPermision.dispatch_setting?.status)}`}
                  style={{
                    marginLeft: "10px",
                    padding: "5px 10px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "500",
                    textTransform: "uppercase",
                  }}
                >
                  {showPermision.dispatch_setting?.status}
                </span></h4>
              </div>
              {showPermision.dispatch_setting?.web == 1 && <>
                <div className='__setf_branc_sepBx'>
                  <h4>POD Submission is Mandatory before Trip End </h4>

                  <div className="_flxOtr">

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="pod_before_trip_end_yes1"
                        type="radio"
                        name="pod_before_trip_end"
                        value="1"
                        checked={form?.pod_before_trip_end === 1}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="pod_before_trip_end_yes1"
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="pod_before_trip_end_no1"
                        type="radio"
                        name="pod_before_trip_end"
                        value="0"
                        checked={form?.pod_before_trip_end === 0}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="pod_before_trip_end_no1"
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>
                <div className='__setf_branc_sepBx'>
                  <h4>Supplier Selection at Dispatch</h4>

                  <div className="_flxOtr">
                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="supplier_selection_at_dispatch_yes"
                        type="radio"
                        name="supplier_selection_at_dispatch"
                        value="1"
                        checked={form?.supplier_selection_at_dispatch === 1}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="supplier_selection_at_dispatch_yes"
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="supplier_selection_at_dispatch_no"
                        type="radio"
                        name="supplier_selection_at_dispatch"
                        value="0"
                        checked={form?.supplier_selection_at_dispatch === 0}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="supplier_selection_at_dispatch_no"
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>
                <div className='__setf_branc_sepBx'>
                  <h4>Supplier Freight Chargable on Dispatch</h4>

                  <div className="_flxOtr">

                    {/* View Checkbox */}
                    <div className="_dualCheckr_bx">
                      <input
                        type="checkbox"
                        id="supplier_freight_view"
                        checked={form.permission_at_supplier.supplier_freight.view === 1}
                        onChange={(e) =>
                          handleOnChange('permission_at_supplier.supplier_freight.view', e.target.checked ? 1 : 0)
                        }
                      />
                      <label htmlFor="supplier_freight_view" className="anvLabel">
                        View
                      </label>
                    </div>

                    {/* Mandatory Checkbox */}
                    <div className="_dualCheckr_bx">
                      <input
                        type="checkbox"
                        id="supplier_freight_mandatory"
                        disabled={form.permission_at_supplier.supplier_freight.view === 0}
                        checked={form.permission_at_supplier.supplier_freight.mandatory === 1}
                        onChange={(e) =>
                          handleOnChange('permission_at_supplier.supplier_freight.mandatory', e.target.checked ? 1 : 0)
                        }
                      />
                      <label htmlFor="supplier_freight_mandatory" className="anvLabel">
                        Mandatory
                      </label>
                    </div>

                  </div>
                </div>
                <div className='__setf_branc_sepBx'>
                  <h4>Thappy / Loading Challi option at Dispatch</h4>

                  <div className="_flxOtr">

                    {/* View Checkbox */}
                    <div className="_dualCheckr_bx">
                      <input
                        type="checkbox"
                        id="loading_challi_view"
                        checked={form.loading_challi.view === 1}
                        onChange={(e) =>
                          handleOnChange('loading_challi.view', e.target.checked ? 1 : 0)
                        }
                      />
                      <label htmlFor="loading_challi_view" className="anvLabel">
                        View
                      </label>
                    </div>

                    {/* Mandatory Checkbox */}
                    <div className="_dualCheckr_bx">
                      <input
                        type="checkbox"
                        id="loading_challi_mandatory"
                        checked={form.loading_challi.mandatory === 1}
                        disabled={form.loading_challi.view === 0}
                        onChange={(e) =>
                          handleOnChange('loading_challi.mandatory', e.target.checked ? 1 : 0)
                        }
                      />
                      <label htmlFor="loading_challi_mandatory" className="anvLabel">
                        Mandatory
                      </label>
                    </div>

                  </div>
                </div>
                <div className='__setf_branc_sepBx'>
                  <h4>Dispatch Date & Time (Web App) </h4>

                  <div className="_flxOtr">

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="dispatch_date_time_yes1"
                        type="radio"
                        name="dispatch_date_time"
                        value="1"
                        checked={form?.dispatch_date_time === 1}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="dispatch_date_time_yes1"
                        className="form-check-label"
                      >
                        Prefilled
                      </label>
                    </div>

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="dispatch_date_time_no1"
                        type="radio"
                        name="dispatch_date_time"
                        value="0"
                        checked={form?.dispatch_date_time === 0}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="dispatch_date_time_no1"
                        className="form-check-label"
                      >
                        Add Manually
                      </label>
                    </div>
                  </div>
                </div>
                <div className='__setf_branc_sepBx'>
                  <h4>Market Driver add on Dispatch</h4>

                  <div className="_flxOtr">

                    {/* View Checkbox */}
                    <div className="_dualCheckr_bx">
                      <input
                        type="checkbox"
                        id="market_drive_on_dispatch_view"
                        checked={form.market_drive_on_dispatch.view === 1}
                        onChange={(e) =>
                          handleOnChange('market_drive_on_dispatch.view', e.target.checked ? 1 : 0)
                        }
                      />
                      <label htmlFor="market_drive_on_dispatch_view" className="anvLabel">
                        View
                      </label>
                    </div>

                    {/* Mandatory Checkbox */}
                    <div className="_dualCheckr_bx">
                      <input
                        type="checkbox"
                        id="market_drive_on_dispatch_mandatory"
                        disabled={form.market_drive_on_dispatch.view === 0}
                        checked={form.market_drive_on_dispatch.mandatory === 1}
                        onChange={(e) =>
                          handleOnChange('market_drive_on_dispatch.mandatory', e.target.checked ? 1 : 0)
                        }
                      />
                      <label htmlFor="market_drive_on_dispatch_mandatory" className="anvLabel">
                        Mandatory
                      </label>
                    </div>

                  </div>
                </div>
                <div className='__setf_branc_sepBx'>
                  <h4>Show Route Customization on Trip Creation </h4>

                  <div className="_flxOtr">

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="show_route_customization_yes1"
                        type="radio"
                        name="route_customization_on_trip"
                        value="1"
                        checked={form?.route_customization_on_trip === 1}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="show_route_customization_yes1"
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>

                    <div className="_dualCheckr_bx">
                      <input
                        className="form-check-input"
                        style={{ cursor: "pointer" }}
                        id="show_route_customization_on1"
                        type="radio"
                        name="route_customization_on_trip"
                        value="0"
                        checked={form?.route_customization_on_trip === 0}
                        onChange={({ target: { name, value } }) => handleOnChange(name, value)}
                      />
                      <label
                        htmlFor="show_route_customization_on1"
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </>}

            </div>

            <div className='__setf_brancBx'>
              <div className='__setf_brHead'>
                <h4>Print Number Generation  <span
                  className={`badge bg-${getStatusColor(showPermision.print_setting?.status)}`}
                  style={{
                    marginLeft: "10px",
                    padding: "5px 10px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "500",
                    textTransform: "uppercase",
                  }}
                >
                  {showPermision.print_setting?.status}
                </span></h4>
              </div>
              {showPermision.print_setting?.web == 1 && <div className='__setf_branc_sepBx pt-4 pb-3'>
                <div style={{ maxWidth: '280px', width: '100%' }}>
                  <CommonInput
                    type="text"
                    placeholder="Branch Trip Number"
                    label="Branch Trip Number"

                    settingIcon={true}
                    onClick={handleLrFunctionality}
                    disabled={true}
                    isSettingHnadle={handleLrFunctionality}
                    value={isLrNumber ? isLrNumber : tripSeries}
                  />
                </div>
                <div style={{ maxWidth: '280px', width: '100%' }}>
                  <CommonInput
                    type="text"
                    placeholder="Branch Invoice Number"
                    label="Branch Invoice Number"

                    settingIcon={true}
                    onClick={handleInvoiceFunctionality}
                    disabled={true}
                    isSettingHnadle={handleInvoiceFunctionality}
                    value={isInvoiceNumber ? isInvoiceNumber : invoiceSeries}
                  />
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>

      <div className='bottomFix'>
        <button className='_addComm_btn' onClick={handleSubmit} disabled={disableButton}>{loading ? "Updating.." : "Update"}</button>
        <button className='_cancel_btn' onClick={() => getDataBranchDetails(id, companyId)}>Cancel</button>
      </div>

      {isOpenLrSeries && <BranchSeriesModal {...isLrSeriesModalProps} />}

      {showAddNewLrSeries && <AddNewSeriesTripModal {...addNewSeriesModalProps} />}

      {isOpenInvoiceSeries && <BranchSeriesInvoiceModal {...isInvoiceSeriesModalProps} />}

      {showAddNewInvoiceSeries && <AddNewSeriesInvoiceModal {...addNewSeriesInvoiceModalProps} />}
    </>
  )
}

export default BranchSetting